import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useNavigate } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { PrimeReactProvider } from 'primereact/api'

import {
  NavBlockerContextProvider,
  PanelContextProvider,
  ThemeContextProvider,
  ToastContextProvider,
} from '../../../contexts'
import { SplitViewContextProvider } from '../../../contexts/splitView'
import { PermissionsContextProvider } from '../../../features/authorization'
import { MaintenanceProvider } from '../../../features/maintenance'
import { PrimeReactLocalsProvider } from '../../../features/primereactLocalsProvider'
import { ConfigContextProvider } from '../../../features/ui-config'
import { UserGuideContextProvider } from '../../../features/user-guide'
import { CustomNavigationClient } from '../../../utils/auth'
import { FallbackRender } from '../../errors'

type Props = {
  publicClient: PublicClientApplication
}

export const ProviderLayout: React.FC<Props> = ({ publicClient }) => {
  const navigate = useNavigate()

  const navigationClient = new CustomNavigationClient(navigate)
  publicClient.setNavigationClient(navigationClient)

  return (
    <MsalProvider instance={publicClient}>
      <PermissionsContextProvider>
        <NavBlockerContextProvider>
          <ThemeContextProvider>
            <UserGuideContextProvider>
              <SplitViewContextProvider>
                <ConfigContextProvider>
                  <PrimeReactLocalsProvider>
                    <PrimeReactProvider value={{ pt }}>
                      <ToastContextProvider position="bottom-right">
                        <PanelContextProvider>
                          <MaintenanceProvider>
                            <ErrorBoundary FallbackComponent={FallbackRender}>
                              <Outlet />
                            </ErrorBoundary>
                          </MaintenanceProvider>
                        </PanelContextProvider>
                      </ToastContextProvider>
                    </PrimeReactProvider>
                  </PrimeReactLocalsProvider>
                </ConfigContextProvider>
              </SplitViewContextProvider>
            </UserGuideContextProvider>
          </ThemeContextProvider>
        </NavBlockerContextProvider>
      </PermissionsContextProvider>
    </MsalProvider>
  )
}

const pt = {
  dialog: {
    root: { className: 'bg-white' },
  },
}
